
import * as _ from 'lodash';
function getMonthDate(bias, getTimestamps,d) {
	bias = bias || 0;
	d = d || new Date();
	const result = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + bias, 1));
	return getTimestamps ? result.getTime() / 1000 : result;
}

function date_format(date,fmt){
	const o = {
		'M+': date.getMonth() + 1, // 月份
		'D+': date.getDate(), // 日
		'h+': date.getHours(), // 小时
		'm+': date.getMinutes(), // 分
		's+': date.getSeconds(), // 秒
		'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
		'S': date.getMilliseconds(), // 毫秒
	};
	if (/(Y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	for (const k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			const v = o[k].toString();
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (v) : (('00' + v).substr((v.toString()).length)));
		}
	}
	return fmt;
}

function columnTimestamp2Month(row, column, cellValue, index){
	const d = new Date(cellValue*1000);
	return date_format(d,'YYYY-MM');
}

function getCookies(names) {
	const result = {};
	const cookies = document.cookie.split('; ');
	for( const name of names) {
		for(const cookie of cookies){
			if(cookie.match(name)){
				result[name] = cookie.split('=')[1];
				break;
			}
		}
	}
	return result;
}

function setCookies(data, days) {
	var date = new Date;
	date.setTime(date.getTime() + 24*60*60*1000*days);
	for(const name in data) {
		document.cookie = name + "=" + data[name] + ";path=/;expires=" + date.toGMTString();
	}
}

function clearAllCookie() {
	const keys = document.cookie.match(new RegExp("([^ ;][^;]*)(?=(=[^;]*)(;|$))", "gi"));
	if(keys) {
		for(const key of keys) {
			document.cookie = key + '=0;expires=' + new Date(0).toUTCString()
		}
	}
}

function attachmentDownload(fileInfo) {

	function saveAs(data, name) {
		var urlObject = window.URL || window.webkitURL || window;
		var export_blob = new Blob([data]);
		var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
		save_link.href = urlObject.createObjectURL(export_blob);
		save_link.download = name;
		save_link.click();
	}
	const url = '/preview?download=1&file=' + fileInfo.file_path;
	const xhr = new XMLHttpRequest();
	xhr.open('GET', url, true);
	xhr.responseType = 'blob';
	//xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
	xhr.onload = () => {
		if (xhr.status === 200) {
			// 获取文件blob数据并保存
			var fileName = fileInfo.file_name;
			saveAs(xhr.response, fileName);
		}
	};

	xhr.send();
}

export {date_format,getMonthDate,columnTimestamp2Month,getCookies,setCookies,clearAllCookie,_,attachmentDownload}